import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconClient = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1,
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		strokeLinecap: "round",
		d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
	})
});
export { SvgIconClient as ReactComponent };
